import { createFileRoute } from '@tanstack/react-router'
import { TaskList } from '@/features/tasks/TaskList'
import { PageHeading } from '@/components/PageHeading'

/**
 * Tasks is the "No list" view.
 *
 * It used to show everything and take `?list=none` to narrow to the unfiled
 * ones. Now that a task in a list appears only in that list, the narrow view
 * is the only view — and a filter whose two settings produce the same screen
 * is a control that does nothing.
 */
export const Route = createFileRoute('/tasks')({
  component: TasksPage,
})

function TasksPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Tasks" meta="In no list" />
      <div className="mt-6">
        <TaskList />
      </div>
    </div>
  )
}
